'use client'

import type {RetreatQuestion} from './types'
import {useTranslate} from '@local/hooks'
import {Button} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import {useState} from 'react'
import {AskQuestionSlideout} from './AskQuestionsSlideout'
import {PrivateRetreatSlideout} from './PrivateRetreatSlideout'

export interface PrivateRetreatPanelsProps {
	className?: string
	askQuestion: {
		listID: string
		successText: string
		successTitle: string
		retreatList: Array<{label:string, id:string, value:string}>
	}
	organizeRetreatQuestions: {
		listID: string
		successText: string
		successTitle: string
		questions: RetreatQuestion[]
	}
}

export const PrivateRetreatPanels = ({className, askQuestion, organizeRetreatQuestions}:PrivateRetreatPanelsProps) => {
	const locale = useTranslate()
	const [isPrivateOpen, setIsPrivateOpen] = useState<boolean>(false)
	const [isQuestionOpen, setIsQuestionOpen] = useState<boolean>(false)
	return (
		<>
			<div className={cx('mx-auto flex flex-col lg:flex-row justify-center gap-10 lg:gutter-gap-1 lg:pb-70', className)}>
				<Button
					small
					className='w-full lg:span-w-3'
					variant='primary'
					onClick={() => setIsPrivateOpen(true)}
					border>
					{locale('Organize a private experience')}
				</Button>
				<Button
					small
					className='w-full lg:span-w-3'
					onClick={() => setIsQuestionOpen(true)}
					variant='secondary-transparent'>
					{locale('Ask a question')}
				</Button>
			</div>

			{organizeRetreatQuestions && (
				<PrivateRetreatSlideout {...organizeRetreatQuestions} isOpen={isPrivateOpen} onClickClose={() => setIsPrivateOpen(false)} />
			)}
			{askQuestion && (
				<AskQuestionSlideout {...askQuestion} isOpen={isQuestionOpen} onClickClose={() => setIsQuestionOpen(false)} />
			)}
		</>
	)
}
